import {
    createElementVNode as _$ce,
    className as _$cn,
    createUnknownComponentVNode as _$cc,
    createVNode as _$cv,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    noop as _$no,
    createCommentVNode as _$ccv,
} from 'intact';
import {FileCardList} from '../fileCard';
import {Icon} from '../icon';
import {addStyle, getRestProps} from '../utils';
import {makeStyles} from './styles';
import {senderSendIcon, senderStopIcon, senderAttachSvg} from './icons';
import {_$} from '../../i18n';
import {isInvalid, isNumber, noop} from 'intact-shared';

var _$tmp0 = {
    'aria-hidden': 'true'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        isFocus,
        isDisabled,
        isGenerating,
        isLoading,
        isSendButtonDisabled,
        handleKeydown,
        handleInput,
        handleFocus,
        handleBlur,
        handleSendClick,
        send,
        stopGenerate,
    } = this.input;
    
    const {
        getAcceptAttr,
        isMultiple,
        onInputChange,
        pickFiles,
        removeAttachment,
    } = this.upload;
    const dragController = this.dragController;
    const {handlePaste} = this.pasteController;
    
    let {
        className, style, value, placeholder, readonly,
        width, maxHeight, type, dragFile: enableDragFile,
        attachments, showAttachmentsButton, uploadProps,
    } = this.get();
    const {k} = this.config;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || value === undefined || value === null || value === '') return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const renderSlot = (name) => $blocks[name] ? $blocks[name](noop) : undefined;
    const headerSlot = renderSlot('header');
    const footerSlot = renderSlot('footer');
    const beforeInputSlot = renderSlot('beforeInput');
    const configureSlot = renderSlot('configure');
    const attachmentsButtonSlot = renderSlot('attachmentsButton');
    const hasHeaderSlot = !isEmptySlot(headerSlot);
    const hasFooterSlot = !isEmptySlot(footerSlot);
    const hasBeforeInputSlot = !isEmptySlot(beforeInputSlot);
    const hasConfigureSlot = !isEmptySlot(configureSlot);
    const hasAttachmentsButtonSlot = !isEmptySlot(attachmentsButtonSlot);
    
    const disabled = isDisabled();
    const generating = isGenerating();
    const loading = isLoading();
    const sendDisabled = isSendButtonDisabled();
    const list = attachments || [];
    const hasAttachments = list.length > 0;
    const limit = uploadProps && uploadProps.limit;
    const reachLimit = limit !== undefined && limit !== null && list.length >= Number(limit);
    const isImage = type === 'image';
    const isDirectory = !!(uploadProps && uploadProps.directory);
    
    // 文本模式下，所有附件统一按「文件卡」呈现，避免引入额外的文件夹展示语义。
    // 图片模式下把 type 交给 FileCard 自动识别（基于 name/src），避免业务透传 MIME 干扰媒体类型判断。
    const renderItems = isImage
        ? list.map(it => ({...it, type: undefined}))
        : list.map(it => ({...it, type: 'file'}));
    
    // 图片模式即便没有附件也要展示 FileCardList，用来承载末尾的虚线 + 框。
    const showAttachmentsArea = isImage || hasAttachments;
    // 图片模式下不展示左下默认附件按钮，由 FileCardList 末尾的 + 框替代；用户自定义 slot 仍可保留。
    const showDefaultAttachBtn = !isImage && !$blocks.attachmentsButton && showAttachmentsButton !== false;
    const showAttachSlot = !isImage && hasAttachmentsButtonSlot;
    const showToolbarLeft = showAttachSlot || showDefaultAttachBtn;
    const onAttachmentClick = (item, e) => {
        this.trigger('attachmentClick', item, e);
    };
    const onAttachmentDelete = (item, e) => {
        this.trigger('attachmentDelete', item, e);
        removeAttachment(item);
    };
    
    const classNameObj = {
        [`${k}-sender`]: true,
        [`${k}-sender-${type}`]: true,
        [`${k}-sender-disabled`]: disabled,
        [className]: className,
        [makeStyles(k)]: true,
    };
    
    // 整个输入外框 k-sender 的宽度
    if (width != null) {
        style = addStyle(style, {width: isNumber(width) ? `${width}px` : width});
    }
    
    // 整个输入外框 k-sender-shell 的最大高度（与 props maxHeight 一致）；未传时走 styles 中默认 300
    const shellStyle = maxHeight != null
        ? {maxHeight: isNumber(maxHeight) ? `${maxHeight}px` : maxHeight}
        : undefined;
    
    const placeholderText = placeholder != null ? placeholder : _$('输入对话内容（Enter发送， Shift + Enter 换行）');
    
    const defaultSendButton = (
        _$ce(2, 'button', (
            _$ce(2, 'img', null, 1, _$cn(`${k}-sender-send-icon`), {
                'src': generating ? senderStopIcon : senderSendIcon,
                'alt': '',
                'draggable': false
            })
        ), 2, _$cn(`${k}-sender-send-btn`), {
            'type': 'button',
            'disabled': !generating && sendDisabled,
            'ev-click': handleSendClick,
            'title': generating ? _$('停止生成') : _$('发送'),
            'aria-label': generating ? _$('停止生成') : _$('发送')
        })
    );
    
    const defaultAttachButton = (
        _$ce(2, 'button', null, 1, _$cn(`${k}-sender-attach-btn`), {
            'type': 'button',
            'disabled': disabled,
            'ev-click': pickFiles,
            'title': isDirectory ? _$('上传文件夹') : _$('上传附件'),
            'aria-label': isDirectory ? _$('上传文件夹') : _$('上传附件'),
            'innerHTML': senderAttachSvg
        })
    );
    
    // type='image' 末尾的虚线 + 框，与 Upload 画廊的 + 卡片视觉等效；点击触发文件选择。
    const imageAddBox = (
        _$ce(2, 'div', (
            _$cc(Icon, {
                'className': _$cn(`${k}-icon-add-bold`),
                'size': 'large'
            })
        ), 2, _$cn({
            [`${k}-sender-image-add`]: true,
            [`${k}-sender-image-add-disabled`]: disabled,
        }), {
            'ev-click': disabled ? undefined : pickFiles,
            'role': 'button',
            'title': _$('上传图片'),
            'aria-label': _$('上传图片')
        })
    );
    
    const sendButtonSlotParams = {
        generating, disabled: sendDisabled, loading, send, stopGenerate,
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this),
        'style': style
    }, [
        (hasHeaderSlot) ?
            _$ce(2, 'div', headerSlot, 0, _$cn(`${k}-sender-header`)) :
            undefined,
        _$ce(2, 'div', [
            (showAttachmentsArea) ?
                _$ce(2, 'div', (
                    (isImage) ?
                        _$cc(FileCardList, {
                            'items': renderItems,
                            'deleteable': true,
                            'overflow': 'scrollY',
                            'ev-click': onAttachmentClick,
                            'ev-delete': onAttachmentDelete,
                            '$blocks': function($blocks) {
                                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                                return (
                                    (
                                        (_$blocks['extension'] = function($super) {
                                            return !disabled && !reachLimit ? imageAddBox : undefined;
                                        }),
                                        (__$blocks['extension'] = function($super, data) {
                                            var block = $blocks['extension'];
                                            var callBlock = function() {
                                                return _$blocks['extension'].call($this, $super, data);
                                            };
                                            return block ?
                                                block.call($this, callBlock, data) :
                                                callBlock();
                                        })
                                    ),
                                    __$blocks
                                );
                            }.call($this, _$em)
                        }) :
                        _$cc(FileCardList, {
                            'items': renderItems,
                            'deleteable': true,
                            'overflow': 'scrollY',
                            'ev-click': onAttachmentClick,
                            'ev-delete': onAttachmentDelete
                        })
                ), 2, _$cn({
                    [`${k}-sender-attachments`]: true,
                    [`${k}-sender-attachments-${type}`]: true,
                })) :
                undefined,
            (hasBeforeInputSlot) ?
                _$ce(2, 'div', beforeInputSlot, 0, _$cn(`${k}-sender-before-input`)) :
                undefined,
            _$ce(2, 'div', (
                _$ce(256, 'textarea', null, 1, _$cn(`${k}-sender-input`), {
                    'rows': 1,
                    'value': value,
                    'placeholder': placeholderText,
                    'disabled': disabled,
                    'readOnly': readonly,
                    'ev-input': handleInput,
                    'ev-keydown': handleKeydown,
                    'ev-paste': handlePaste,
                    'ev-focus': handleFocus,
                    'ev-blur': handleBlur
                }, null, this.textareaRef)
            ), 2, _$cn(`${k}-sender-input-area`)),
            _$ce(2, 'div', [
                (showToolbarLeft) ?
                    _$ce(2, 'div', (
                        (showAttachSlot) ?
                            attachmentsButtonSlot :
                            showDefaultAttachBtn ?
                                defaultAttachButton :
                                undefined
                    ), 0, _$cn(`${k}-sender-toolbar-left`)) :
                    undefined,
                (hasConfigureSlot) ?
                    _$ce(2, 'div', configureSlot, 0, _$cn(`${k}-sender-toolbar-middle`)) :
                    undefined,
                _$ce(2, 'div', (
                    ($blocks.sendButton) ?
                        (
                            (_$blocks['sendButton'] = function($super) {
                                return null;
                            }),
                            (__$blocks['sendButton'] = function($super, data) {
                                var block = $blocks['sendButton'];
                                var callBlock = function() {
                                    return _$blocks['sendButton'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            }),
                            __$blocks['sendButton'](_$no, sendButtonSlotParams)
                        ) :
                        defaultSendButton
                ), 0, _$cn(`${k}-sender-toolbar-right`))
            ], 0, _$cn(`${k}-sender-toolbar`)),
            _$ccv(' 放末尾，避免挡住 attachments + input-area 等相邻选择器，且 absolute 不影响布局 '),
            _$ce(64, 'input', null, 1, _$cn(`${k}-sender-file-input`), {
                'type': 'file',
                'accept': getAcceptAttr(),
                'multiple': isMultiple(),
                'directory': isDirectory ? '' : undefined,
                'webkitdirectory': isDirectory ? '' : undefined,
                'ev-change': onInputChange
            }, null, this.fileInputRef)
        ], 0, _$cn({[`${k}-sender-shell`]: true, [`${k}-sender-active`]: isFocus.value && !disabled}), {
            'style': shellStyle
        }),
        (hasFooterSlot) ?
            _$ce(2, 'div', footerSlot, 0, _$cn(`${k}-sender-footer`)) :
            undefined,
        (enableDragFile && dragController.dragOver.value) ?
            _$ce(2, 'div', (
                _$ce(2, 'div', [
                    _$cc(Icon, {
                        'className': _$cn(`${k}-icon-upload`),
                        'size': 'large'
                    }),
                    _$ce(2, 'div', _$('文件拖动到此处即可上传'), 0, _$cn(`${k}-sender-drag-text`))
                ], 4, _$cn(`${k}-sender-drag-card`))
            ), 2, _$cn(`${k}-sender-drag-mask`), _$tmp0) :
            undefined
    ]);
};